import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@apollo/client";
import { Alert, Button, CircularProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BALLOT_BOX_ENTRY, BALLOT_BOX_KEYS } from "@/queries/BallotBoxLog";
import { IPermissions } from "@/types/keycloak";
import { BallotEntryEvidence, } from "./BallotEntryEvidence";
export var BallotEntryProof = function (_a) {
    var _b, _c;
    var electionEventId = _a.electionEventId, electionId = _a.electionId, ballotId = _a.ballotId, pseudonym = _a.pseudonym, selectedEntry = _a.selectedEntry, zone = _a.zone;
    var t = useTranslation().t;
    var context = { headers: { "x-hasura-role": IPermissions.LOGS_READ } };
    var entry = useQuery(BALLOT_BOX_ENTRY, {
        variables: { electionEventId: electionEventId, electionId: electionId, ballotId: ballotId },
        fetchPolicy: "no-cache",
        context: context,
    });
    var keys = useQuery(BALLOT_BOX_KEYS, {
        variables: { electionEventId: electionEventId, electionId: electionId, ballotId: ballotId },
        fetchPolicy: "no-cache",
        context: context,
    });
    var proof = (_b = entry.data) === null || _b === void 0 ? void 0 : _b.ballot_box_entry.payload;
    var trust = (_c = keys.data) === null || _c === void 0 ? void 0 : _c.ballot_box_keys.payload;
    var loading = entry.loading || keys.loading;
    var retry = function () {
        void entry.refetch().catch(function () { return undefined; });
        void keys.refetch().catch(function () { return undefined; });
    };
    var contextMatches = (proof === null || proof === void 0 ? void 0 : proof.ballot_id) === ballotId &&
        (proof === null || proof === void 0 ? void 0 : proof.pseudonym) === pseudonym &&
        (trust === null || trust === void 0 ? void 0 : trust.election_id) === electionId &&
        (trust === null || trust === void 0 ? void 0 : trust.election_event_id) === electionEventId;
    return (_jsx(Stack, { spacing: 2, children: loading ? (_jsx(CircularProgress, { "aria-label": t("ballotPrivacy.checking") })) : entry.error || keys.error || !proof || !trust || !contextMatches ? (_jsxs(_Fragment, { children: [_jsx(Alert, { severity: "error", children: t("ballotPrivacy.proofError") }), _jsx(Button, { onClick: retry, children: t("ballotPrivacy.retry") })] })) : (_jsx(BallotEntryEvidence, { trust: trust, proof: proof, selectedEntry: selectedEntry, zone: zone, onRetry: retry })) }));
};
